export const USD_ISO4217 = 840
export const EUR_ISO4217 = 978
